package org.multiplatform.kotfolio.layout

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.util.Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

class NeoLayoutData(val title: String,
                     val description: String? = "",
                     val  blogProperties: BlogProperties)

private val AMBER_500 = Color.rgb(245, 158, 11)

@Layout
@Composable
fun NeoLayout(content: @Composable () -> Unit) {
    val ctx = rememberPageContext()

    val data = ctx.data.getValue<NeoLayoutData>()
    LaunchedEffect(data.title) {
        document.title = data.title
    }

    LaunchedEffect(Unit) {
        js("hljs.highlightAll()")
    }

    Box(
        Modifier.fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            PageContentStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            P(
                attrs = Modifier
                    .margin(top = 24.px, bottom = 10.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(35.px)
                    .fontWeight(FontWeight.Black)
                    .color(Colors.Black)
                    .lineHeight(1.2)
                    .toAttrs(),
            ) { Text(data.blogProperties.title) }

            P(
                attrs = Modifier
                    .margin(bottom = 45.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(25.px)
                    .fontWeight(FontWeight.Bold)
                    .color(AMBER_500)
                    .toAttrs(),
            ) { Text(data.blogProperties.title) }

            content()
        }
    }
}

/*@InitRoute()
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(
        NeoLayoutData(
            "Air",
            "Common wrapper class is Kotlin class. It is used to clean code, wrapper the code easy to handle response success, failed and loading.",
            BlogProperties("Kids", "Air")
        )
    ) // Set your desired tab title here
}

@Page("air")
@Composable
@Layout(".layout.BlogLayout")
fun KidsAirPage()
{

}*/